module.exports = global.config = {
  host: "https://api-gateway.sampangkab.go.id/be-bppkad",
  subdomain: "bppkad",
};
